export const NO_STORE = '-1'
export const NO_REPRESENTATIVE = '-1'
export const SET_STORE = 'SET_STORE'
